import { Search } from 'lucide-react'
import { TOOLS } from '@/components/ToolbarButton/ToolItems'
import ToolbarButton from '@/components/ToolbarButton'
import { ModeType } from '@/types/graph'
import { useTranslation } from '@/i18n'

interface GraphToolbarProps {
  currentMode: string
  isReadOnly: boolean
  onToolChange: (type: string) => void
  isCommentActive?: boolean
  onSearchClick?: () => void
  isSearchActive?: boolean
}

const GRAPH_TOOLS = TOOLS.filter((tool) => tool.type === 'select' || tool.type === 'hand' || tool.type === 'comment')
const READ_ONLY_TOOLS = TOOLS.filter((tool) => tool.type === 'hand')

const ICON_SIZE = 22

const GraphToolbar = ({ currentMode, onToolChange, isReadOnly, isCommentActive, onSearchClick, isSearchActive }: GraphToolbarProps) => {
  const tools = isReadOnly ? READ_ONLY_TOOLS : GRAPH_TOOLS
  const { t } = useTranslation()

  const getStatus = (type: string) => {
    // When search is active, no other tool should be highlighted
    if (isSearchActive) return false
    if (type === 'comment') return isCommentActive || false
    if ((currentMode === ModeType.Select && type === 'select') ||
        (currentMode === ModeType.Drag && type === 'hand')) {
      return true
    }
    return false
  }

  return (
    <div className="flex flex-col absolute top-[50%] mt-[-180px] left-4 bg-white dark:bg-dark-card shadow-lg gap-4 px-3 py-4 rounded-lg border border-gray-200 dark:border-dark-border">
      {onSearchClick && (
        <ToolbarButton
          name={String(t('board:toolbar.tools.search'))}
          isactive={isSearchActive || false}
          onClick={onSearchClick}
        >
          <Search size={ICON_SIZE} />
        </ToolbarButton>
      )}
      {tools.map(({ nameKey, icon, type, disabled }) => (
        <ToolbarButton
          name={t(nameKey)}
          key={nameKey}
          isactive={getStatus(type) as boolean}
          onClick={() => {
            onToolChange(type)
          }}
          disabled={disabled}
        >
          {icon}
        </ToolbarButton>
      ))}
    </div>
  )
}

export default GraphToolbar
